export default __webpack_public_path__ + "static/media/notification.56c248cf.svg";